import React from 'react';
import {connect} from 'react-redux';
import {CollapsibleLinkpile} from '@homeaway/react-linkpile';

import './styles.less';

const mapStateToProps = (state, props) => ({
    ...state.seoLinkpile,
    isMobile: state.config.isMobile,
    site: state.config.site.name,
    forceExpanded: props.forceExpanded,
    useSlpCanonical: state.options.useSlpCanonical,
});

export const SeoLinkpileComponent = (props) => {
    if (props?.categories && props?.useSlpCanonical) {
        props.categories.forEach((category) => {
            category.links = category.links.filter(
                (link) => !link.url.includes('search')
            );
        });
    }

    return <CollapsibleLinkpile {...props} />;
};

export const SeoLinkpile = connect(mapStateToProps)(SeoLinkpileComponent);
SeoLinkpile.displayName = 'SeoLinkpile';

export default SeoLinkpile;
